import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import axios from "axios";
import { QRCodeSVG } from "qrcode.react";
import styles from "./HomeStyles";



const CHOCOLATE_IMAGES = {
  Kitkat: "https://sadhanlab.com/wrapper/kitkat.png",
  Dairy_Milk: "https://sadhanlab.com/wrapper/dairy_milk.png",
};


const Home = () => {

const [quantity, setQuantity] = useState(6);
const [customQuantity, setCustomQuantity] = useState("");
const [price, setPrice] = useState(100 + 30 * 6);



  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  const [name, setName] = useState("");
  const [photo, setPhoto] = useState(null);
  const [eventText, setEventText] = useState("Happy Birthday");
  const [customEventText, setCustomEventText] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [scale, setScale] = useState(1);

  const [chocolateType, setChocolateType] = useState("Kitkat");


  // Validation States
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      const padding = 40;
      if (screenWidth < 540) {
        setScale((screenWidth - padding) / 500);
      } else {
        setScale(1);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);







  useEffect(() => {
  let finalQty = quantity;

  if (quantity === "custom") {
    const parsed = parseInt(customQuantity);
    if (!isNaN(parsed) && parsed > 30) {
      finalQty = parsed;
    } else {
      setPrice(0);
      return;
    }
  }

  const calculatedPrice =
    finalQty <= 30
      ? 150 + 30 * finalQty
      : 30 * finalQty;

  setPrice(calculatedPrice);
}, [quantity, customQuantity]);














  // Updated Phone Input Handler
  const handlePhoneChange = (e) => {
    const val = e.target.value;
    // Allow only digits, +, and prevent more than 15 chars for safety
    // const filteredVal = val.replace(/[^0-9+]/g, "");
    const filteredVal = val.replace(/[^0-9\u09E6-\u09EF+]/g, "");

    setMobile(filteredVal);

    // Bangladesh/General Phone Regex: Optional +88 or 0088 followed by exactly 11 digits
    const phoneRegex = /^(\+88|0088)?\d{11}$/;
    
    if (filteredVal === "") {
      setPhoneError("");
    } else if (!phoneRegex.test(filteredVal)) {
      setPhoneError("Invalid format. Use 11 digits (Optional: +88 or 0088)");
    } else {
      setPhoneError("");
    }
  };

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     if (file.size > 1024 * 1024) {
  //       setWarningMessage("Image size exceeds 1MB.");
  //       return;
  //     }
  //     setWarningMessage("");
  //     const reader = new FileReader();
  //     reader.onload = (re) => setPhoto(re.target.result);
  //     reader.readAsDataURL(file);
  //   }
  // };



  const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    setWarningMessage("");
    const reader = new FileReader();
    reader.onload = (re) => setPhoto(re.target.result);
    reader.readAsDataURL(file);
  }
};





  // const generateOrderId = () => {
  //   const now = new Date();
  //   const timestamp = now.toISOString().replace(/[-:.TZ]/g, "");
  //   return `${mobile.replace('+', '')}_${timestamp}_${customerName.replace(/\s+/g, "").toUpperCase()}`;
  // };






  const generateOrderId = () => {
  const now = new Date();
  const timestamp = now.toISOString().replace(/[-:.TZ]/g, "");

  return `${mobile.replace('+', '')}_${quantity}_${chocolateType}_${timestamp}_${customerName.replace(/\s+/g, "").toUpperCase()}`;
};








// const smartCompressCanvas = async (canvas, maxSizeMB = 2) => {
//   const maxBytes = maxSizeMB * 1024 * 1024;

//   let width = canvas.width;
//   let height = canvas.height;

//   let quality = 0.92;
//   let blob;

//   const tempCanvas = document.createElement("canvas");
//   const ctx = tempCanvas.getContext("2d");

//   const draw = () => {
//     tempCanvas.width = width;
//     tempCanvas.height = height;

//     ctx.clearRect(0, 0, width, height);

//     // High quality scaling
//     ctx.imageSmoothingEnabled = true;
//     ctx.imageSmoothingQuality = "high";

//     ctx.drawImage(canvas, 0, 0, width, height);
//   };

//   draw();

//   blob = await new Promise(res =>
//     tempCanvas.toBlob(res, "image/jpeg", quality)
//   );

//   // Step 1: reduce quality first (preserves sharpness)
//   while (blob.size > maxBytes && quality > 0.6) {
//     quality -= 0.04;

//     blob = await new Promise(res =>
//       tempCanvas.toBlob(res, "image/jpeg", quality)
//     );
//   }

//   // Step 2: reduce resolution only if required
//   while (blob.size > maxBytes) {
//     width *= 0.92;
//     height *= 0.92;

//     draw();

//     blob = await new Promise(res =>
//       tempCanvas.toBlob(res, "image/jpeg", quality)
//     );
//   }

//   console.log(
//     "Final Size:",
//     (blob.size / 1024 / 1024).toFixed(2),
//     "MB"
//   );

//   return blob;
// };










const smartCompressCanvas = async (canvas, maxSizeMB = 2) => {
  const maxBytes = maxSizeMB * 1024 * 1024;

  let width = canvas.width;
  let height = canvas.height;

  const tempCanvas = document.createElement("canvas");
  const ctx = tempCanvas.getContext("2d");

  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  const draw = () => {
    tempCanvas.width = width;
    tempCanvas.height = height;
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(canvas, 0, 0, width, height);
  };

  draw();

  const blobFromQuality = (quality) =>
    new Promise((resolve) =>
      tempCanvas.toBlob(resolve, "image/jpeg", quality)
    );

  // FIRST: try maximum quality
  let bestBlob = await blobFromQuality(1.0);

  if (bestBlob.size <= maxBytes) {
    console.log(
      "No compression needed:",
      (bestBlob.size / 1024 / 1024).toFixed(2),
      "MB"
    );
    return bestBlob;
  }

  // SECOND: binary search for BEST quality near limit
  let minQ = 0.5;
  let maxQ = 1.0;
  let bestQuality = 0.92;

  for (let i = 0; i < 8; i++) {
    const midQ = (minQ + maxQ) / 2;

    const blob = await blobFromQuality(midQ);

    if (blob.size > maxBytes) {
      maxQ = midQ;
    } else {
      minQ = midQ;
      bestQuality = midQ;
      bestBlob = blob;
    }
  }

  // THIRD: reduce resolution only if still too large
  while (bestBlob.size > maxBytes) {
    width *= 0.95;
    height *= 0.95;
    draw();

    bestBlob = await blobFromQuality(bestQuality);
  }

  console.log(
    "Final Size:",
    (bestBlob.size / 1024 / 1024).toFixed(2),
    "MB",
    "Quality:",
    bestQuality.toFixed(3)
  );

  return bestBlob;
};


















  const handlePlaceOrder = async () => {
    // const phoneRegex = /^(\+88|0088)?\d{11}$/;
    const phoneRegex = /^(\+88|0088|\+৮৮|০০৮৮)?[0-9\u09E6-\u09EF]{11}$/;

    if (!customerName || !mobile || !address) {
      alert("Name, Mobile and Address are mandatory.");
      return;
    }


    if (phoneError!="") {
      alert("Please enter a valid mobile number.");
      return;
    }







    if (!phoneRegex.test(mobile)) {
      alert("Please enter a valid 11-digit mobile number (+88/0088 optional).");
      return;
    }




let finalQuantity = quantity;

if (quantity === "custom") {
  finalQuantity = parseInt(customQuantity);
}

if (!finalQuantity || finalQuantity < 6) {
  alert("Please select valid quantity.");
  return;
}

if (quantity === "custom" && finalQuantity <= 30) {
  alert("Manual quantity must be greater than 30.");
  return;
}

if (price <= 0) {
  alert("Enter a valid quantity.");
  return;
}


    setOrderStatus("Please wait...");
    // const orderId = generateOrderId();


const orderId = generateOrderId();

















    try {
      const formData = new FormData();
      formData.append("order_id", orderId);
      formData.append("design_data", JSON.stringify({
        wrapper_name: name,
        event_text: eventText || "",
        custom_event_text: customEventText || "",
      }));
      formData.append("customer_name", customerName);
      formData.append("mobile", mobile);
      formData.append("address", address);
      formData.append("payment_status", "pending");

      formData.append("chocolate_type", chocolateType);




      formData.append("quantity", finalQuantity);
      formData.append("price", price);


      // if (wrapperRef.current) {
      //   const canvas = await html2canvas(wrapperRef.current, {
      //     backgroundColor: "#1a0d05",
      //     scale: 3,
      //     useCORS: true,
      //   });
      //   const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
      //   formData.append("wrapped_image", blob, `${orderId}.png`);
      // }






      if (wrapperRef.current) {
  const canvas = await html2canvas(wrapperRef.current, {
    backgroundColor: "#1a0d05",
    scale: 3,
    useCORS: true,
  });

  const compressedBlob = await smartCompressCanvas(canvas, 2);

  formData.append(
    "wrapped_image",
    compressedBlob,
    `${orderId}.jpg`
  );
}





      const res = await axios.post("https://apiwrapsy.sadhanlab.com/api/orders/", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      navigate(`/payment/${res.data.order_id}`);
    } catch (e) {
      setOrderStatus("Failed to place order.");
    }
  };

  return (
    <div style={styles.container}>









<div style={{ textAlign: "center", marginBottom: "10px" }}>
  <img
    src= "https://sadhanlab.com/wrapper/wrapper_logo.png"
    alt="Wrapsy Logo"
style={{
  width: "150px",
  height: "150px",
  objectFit: "cover",
  marginBottom: "5px",
  borderRadius: "50%",

}}

  />
{/* 
  <h1 style={styles.title}>Wrapsy</h1>
  <p style={styles.subtitle}>Happyness Wrapped</p> */}
</div>


      {/* <h1 style={styles.title}>Wrapsy</h1>
      <p style={styles.subtitle}>Happyness Wrapped</p> */}

      {/* DESIGN CONTROLS */}
      <div style={styles.uiPanel}>
        <input type="text" placeholder="Name to be printed" value={name} onChange={(e) => setName(e.target.value)} style={styles.inputText} />
        <label style={styles.customFileUpload}>
          Upload your Photo
          <input type="file" onChange={handleImageUpload} style={{ display: 'none' }} />
        </label>

        {/* {warningMessage && <div style={{ color: "red", width: "100%", fontSize: "0.8rem" }}>{warningMessage}</div>} */}
                {warningMessage && (
          <div style={{ color: "red", width: "100%", fontSize: "0.8rem" }}>
            {warningMessage} <a href="https://powercompress.com/" target="_blank" rel="noreferrer" style={{ color: "#fff" }}>Compress Here</a>
          </div>
        )}

        <div style={styles.eventOptionsContainer}>
          {["Happy Birthday", "Happy Anniversary", "Gift", "custom"].map((opt) => (
            <label key={opt} style={styles.eventOptionLabel}>
              <input type="radio" name="event" checked={(opt === "custom" && eventText === "") || eventText === opt} onChange={() => setEventText(opt === "custom" ? "" : opt)} />
              {opt === "custom" ? " Custom" : ` ${opt}`}
            </label>
          ))}
        </div>

        {eventText === "" && (
          <input type="text" placeholder="Enter Custom Message" value={customEventText} onChange={(e) => setCustomEventText(e.target.value)} style={styles.customEventInput} />
        )}
      </div>

      {/* WRAPPER PREVIEW */}
      <div style={{ ...styles.canvasArea, height: `${700 * scale}px` }}>
        <div ref={wrapperRef} style={{ ...styles.wrapper, transform: `scale(${scale})` }}>
          <div style={styles.topText}>{(eventText || customEventText || "").toUpperCase()}</div>

          <div style={styles.photoContainerWrapper}>
            <div style={styles.photoContainerInner}>
              <div style={{
                position: "absolute", inset: 0,
                background: photo ? `url(${photo}) center/cover no-repeat` : "#1a0d05",
                display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden"
              }}>
                {!photo && (
                  <svg width="100%" height="100%" viewBox="0 0 400 400">
                    <defs>
                      <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#d4af37" />
                        <stop offset="50%" stopColor="#f9d976" />
                        <stop offset="100%" stopColor="#a67c00" />
                      </linearGradient>
                      <pattern id="diamondPattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
                        <path d="M 20 0 L 40 20 L 20 40 L 0 20 Z" fill="none" stroke="#d4af37" strokeWidth="0.5" opacity="0.3" />
                      </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="#1a0d05" />
                    <rect width="100%" height="100%" fill="url(#diamondPattern)" />
                    <g transform="translate(200, 200)">
                      {[...Array(12)].map((_, i) => (
                        <rect key={i} x="-1" y="-150" width="2" height="300" fill="url(#goldGrad)" opacity="0.2" transform={`rotate(${i * 15})`} />
                      ))}
                      <circle r="80" fill="none" stroke="url(#goldGrad)" strokeWidth="2" />
                      <circle r="70" fill="none" stroke="#d4af37" strokeWidth="0.5" strokeDasharray="5,5" />
                      <path d="M 0 -40 L 10 -10 L 40 0 L 10 10 L 0 40 L -10 10 L -40 0 L -10 -10 Z" fill="url(#goldGrad)" />
                    </g>
                  </svg>
                )}
              </div>
            </div>
          </div>

          <div style={styles.nameSection}>
            <div style={styles.recipientName}>{name.toUpperCase()}</div>
          </div>

          <div style={{
            position: "absolute", bottom: "55px", left: "50%", transform: "translateX(-50%)",
            display: "flex", flexDirection: "column", alignItems: "center",
            backgroundColor: "white", padding: "5px"
          }}>
            <span style={{ fontSize: "14px", fontWeight: "bold", color: "#000", marginBottom: "4px" }}>TO ORDER</span>
            <QRCodeSVG value="https://wrapsy.sadhanlab.com" size={75} level="L" fgColor="#000" bgColor="transparent" />
          </div>
        </div>
      </div>



      {/* CUSTOMER DETAILS */}
      <div style={styles.uiPanel}>
        





{/* CHOCOLATE TYPE SECTION */}
<div style={{ width: "100%", maxWidth: "500px", marginTop: "10px" }}>
  <div style={{ marginBottom: "8px", fontWeight: "bold", color: "#d4af37" }}>
    Select Chocolate Type *
  </div>

  {["Kitkat", "Dairy_Milk"].map((type) => (
    <label
      key={type}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "8px",
        border: "1px solid #d4af37",
        padding: "8px",
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <input
          type="radio"
          name="chocolate_type"
          checked={chocolateType === type}
          onChange={() => setChocolateType(type)}
        />

        <img
          src={CHOCOLATE_IMAGES[type]}
          alt={type}
          style={{
            width: "50px",
            height: "50px",
            objectFit: "contain",
            borderRadius: "6px",
            background: "#fff",
            padding: "2px",
          }}
        />

        <span style={{ color: "#f9d976", fontWeight: "bold" }}>
          {type.replace("_", " ")}
        </span>
      </span>
    </label>
  ))}
</div>








{/* QUANTITY SECTION */}
<div style={{ width: "100%", maxWidth: "500px", marginTop: "10px" }}>
  <div style={{ marginBottom: "8px", fontWeight: "bold", color: "#d4af37" }}>
    Select Quantity *
  </div>

  {[6, 12, 18, 24, 30].map((qty) => (
    <label
      key={qty}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "6px",
        cursor: "pointer",
        border: "1px solid #d4af37",
        padding: "6px 10px",
        borderRadius: "6px",
      }}
    >
      <span>
        <input
          type="radio"
          name="quantity"
          checked={quantity === qty}
          onChange={() => {
            setQuantity(qty);
            setCustomQuantity("");
          }}
          style={{ marginRight: "8px" }}
        />
        {qty} pcs
      </span>
      <span style={{ color: "#f9d976", fontWeight: "bold" }}>
        ৳ {150 + 30 * qty}
      </span>
    </label>
  ))}

  {/* Custom Quantity */}
  <label
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "8px",
      border: "1px solid #d4af37",
      padding: "6px 10px",
      borderRadius: "6px",
      cursor: "pointer",
    }}
  >
    <span>
      <input
        type="radio"
        name="quantity"
        checked={quantity === "custom"}
        onChange={() => setQuantity("custom")}
        style={{ marginRight: "8px" }}
      />
      Above 30
    </span>


<input
  type="number"
  min={31}
  placeholder="Enter qty"
  value={customQuantity}
  onChange={(e) => setCustomQuantity(parseInt(e.target.value, 10))}
  style={{
    width: "80px",
    padding: "4px",
    borderRadius: "4px",
    border: "1px solid #d4af37",
    background: "#000",
    color: "#fff",
  }}
  disabled={quantity !== "custom"}
/>





    
  </label>

  {/* Total Price Display */}
  <div
    style={{
      marginTop: "10px",
      fontSize: "1rem",
      fontWeight: "bold",
      color: "#f97316",
    }}
  >
    Total Price: ৳ {price}
  </div>













</div>






<div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",   // centers horizontally
    justifyContent: "center",
    width: "100%",
        gap: "10px"   // ← add this line

  }}
>
  <input
    type="text"
    placeholder="Your Name *"
    value={customerName}
    onChange={(e) => setCustomerName(e.target.value)}
    style={{
      ...styles.inputText,
      width: "100%",
      maxWidth: "250px",
      textAlign: "center"
    }}
  />



  <div
    style={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: "250px",
      alignItems: "center"
    }}
  >
    <input
      type="text"
      placeholder="Mobile Number * (English)"
      value={mobile}
      onChange={handlePhoneChange}
      style={{
        ...styles.inputText,
        width: "100%",
        maxWidth: "250px",
        borderColor: phoneError ? "red" : "#d4af37",
        textAlign: "center"
      }}
    />

    {phoneError && (
      <span
        style={{
          color: "red",
          fontSize: "0.7rem",
          marginTop: "4px",
          textAlign: "center",
          width: "100%"
        }}
      >
        {phoneError}
      </span>
    )}
  </div>
</div>








        {/* <input type="text" placeholder="Your Name *" value={customerName} onChange={(e) => setCustomerName(e.target.value)} style={styles.inputText} />
        
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '250px' }}>
          <input 
            type="text" 
            placeholder="Mobile Number * (English)" 
            value={mobile} 
            onChange={handlePhoneChange} 
            style={{ ...styles.inputText, maxWidth: '100%', borderColor: phoneError ? 'red' : '#d4af37' }} 
          />
          {phoneError && <span style={{ color: 'red', fontSize: '0.7rem', marginTop: '4px' }}>{phoneError}</span>}
        </div> */}








        <textarea placeholder="Delivery Address *" value={address} onChange={(e) => setAddress(e.target.value)} style={{ ...styles.inputText, width: "100%", height: "80px", maxWidth: "100%" }} />
        











        <button onClick={handlePlaceOrder} disabled={orderStatus === "Please wait..." || !!phoneError} style={{ ...styles.buttonOrder, opacity: (orderStatus === "Please wait..." || !!phoneError) ? 0.6 : 1 }}>
          {orderStatus === "Please wait..." ? "Please wait..." : "Place Order"}
        </button>
        {orderStatus && <div style={styles.orderStatus}>{orderStatus}</div>}
      </div>
    </div>
  );
};

export default Home;